import React, {useState} from 'react'
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { setSettingsView } from '../../../features/videoPlayer/videoPlayer.slice';
import { Box, Slider } from '@mui/material';


const PlaybackSpeed = ({videoRef}) => {
    const [playbackSpeed, setPlaybackSpeed] = useState(videoRef.current ? videoRef.current.playbackRate : 1);

    const dispatch = useDispatch();

    const handleChangeSpeed = (speed) => {
        if (videoRef.current) {
            videoRef.current.playbackRate = speed;
            setPlaybackSpeed(speed);
        }
    };

    const marks = [
        { value: 0.25, label: '0.25x' },
        { value: 0.5, label: '0.5x' },
        { value: 0.75, label: '0.75x' },
        { value: 1, label: '1x' },
        { value: 1.25, label: '1.25x' },
        { value: 1.5, label: '1.5x' },
        { value: 1.75, label: '1.75x' },
        { value: 2, label: '2x' },
    ];

    return (
        <div
            style={{
            position: 'absolute',
            top: '60px',
            right: '30px',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#1A1A1A',
            width: '300px',
            // height: '100px',
            borderRadius: '5px',
            padding: '20px',
            justifyContent: 'space-between',
            // alignItems: 'center',
            color: '#fff',
            zIndex: 3,
            }}
            id="playback-speed-settings"
        >
            <div className='d-flex align-items-center'>
                <FontAwesomeIcon 
                    icon={faChevronLeft} 
                    style={{ cursor: "pointer", color: "#AEAFBA", marginRight: "10px", marginTop: "2px" }} 
                    onClick={() => dispatch(setSettingsView("main"))}
                />
                <h5 className='m-0'>Playback Speed</h5>
            </div>
            <hr />
            <div className='d-flex flex-column'>
                {/* {[0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2].map((speed) => (
                    <div
                        key={speed}
                        className='d-flex flex-row justify-content-between align-items-center'
                        style={{cursor: 'pointer'}}
                        onClick={() => handleChangeSpeed(speed)}
                    >
                        <span>{speed}x</span>
                        {videoRef.current && videoRef.current.playbackRate === speed && (
                            <span>&#10003;</span> // Checkmark
                        )}
                    </div>
                ))} */}
                <Box>
                    <Slider
                        aria-label='playback-speed'
                        value={playbackSpeed}
                        // defaultValue={1}
                        min={0.25}
                        max={2}
                        step={null}
                        marks={marks}
                        onChange={(e, newValue) => handleChangeSpeed(newValue)}
                        valueLabelDisplay="auto"
                        // remove text marks since valueLabelDisplay shows the value
                        sx={{
                            '& .MuiSlider-markLabel': {
                                display: 'none',
                            },
                            // style the thumb and track
                            '& .MuiSlider-thumb': {
                                backgroundColor: '#fff',
                            },
                            '& .MuiSlider-track': {
                                backgroundColor: '#fff',
                            },
                            '& .MuiSlider-rail': {
                                backgroundColor: '#555',
                            },
                        }}
                        // remove margin below the slider
                        style={{ marginBottom: '0px' }}

                    />
                </Box>
            </div>
            {/* <button 
                className='btn btn-secondary mt-3'
                onClick={() => setSettingsView("main")}
            >
                Back to Settings
            </button> */}
        </div>
  )
}

export default PlaybackSpeed